import { createPricesApiClient } from './pricesAPIClient'

export const pricesAPIClient = createPricesApiClient({})
